<template lang="pug">
div.animated.fadeIn
  b-card
    div.row(v-if='loading')
      div.col
        | Loading...
    div.row(v-else)
      div.col-sm-5
        h4.card-title.mb-0
          | {{broadcast.name}}
        div.small.text-muted
          | Broadcast {{uniqueId}}
      div.col-sm-7.hidden-sm-down
        b-btn.pull-right.pill-right(type='button', :variant='broadcast.approval=="denied"?"outline-danger":"danger"', :disabled='broadcast.approval=="denied"' @click='onDeny')
          i.fa.fa-times
          |   Deny
        b-btn.pull-right.pill-left(type='button', :variant='broadcast.approval=="approved"?"outline-success":"success"', :disabled='broadcast.approval=="approved"' @click='onApprove')
          i.fa.fa-check
          |   Approve
    br
    div.row
      div.col-md-2
        | Audience:
      div.col-md-10
        | {{broadcast.audience}}
      div.col-md-2
        | Message:
      div.col-md-10
        | {{broadcast.message}}
      div.col-md-2
        | Campaign Link:
      div.col-md-10
        | https://m.me/{{botName}}/?{{lowerName}}
      div.col-md-2
        | Start Date:
      div.col-md-10
        | {{broadcast.start_date}}
      div.col-md-2
        | End Date:
      div.col-md-10
        | {{broadcast.end_date}}
      div.col-md-2
        | Platforms:
      div.col-md-10
        b-row
          b-col(cols=1 v-b-tooltip.hover='"Email"')
            i.fa.fa-envelope-o(:class='{"text-success": broadcast.email}')
          b-col(cols=1 v-b-tooltip.hover='"SMS"')
            i.fa.fa-mobile(:class='{"text-success": broadcast.sms}')
          b-col(cols=1 v-b-tooltip.hover='"Facebook Messenger"')
            i.fa.fa-facebook(:class='{"text-success": broadcast.messenger}')
</template>

<script>
import { db } from '@/firebase'
import { blast } from '@/api'

const campRef = db.ref('campaign')

export default {
  name: 'dashboard',
  data() {
    return {
      broadcast: {
      },
      broadcastId: this.$route.params.Id,
      errorBlast: false,
      loading: true,
      bot: null,
    }
  },
  mounted: function() {
    campRef.child(this.$route.params.Id).on('value', (snapshot) => {
      this.broadcast = snapshot.val()
      this.loading = false
    })
    this.bot = this.$store.state.bot
  },
  computed: {
    lowerName: function() {
      return this.broadcast.name.toLowerCase().replace(/ /g, '-')
    },
    botName: function() {
      return this.bot.toLowerCase().replace(/ /g, '-')
    },
    uniqueId: function() {
      return '#' + this.broadcastId
    },
  },
  methods: {
    onApprove() {
      var contentFB = {
        platform: 'webPopup',
        campaignGroup: this.broadcast.audience,
        campaign: this.broadcast.message,
      }
      var contentSMS = {
        platform: 'sms',
        campaignGroup: this.broadcast.audience,
        campaign: this.broadcast.message + ' Visit https://m.me/' + this.botName + '/?' + this.lowerName,
      }
      this.broadcast.sms && this.broadcast.messenger && blast(contentSMS)
        .then(function (res) {
          res.error && this.onError(res.error)
        }.bind(this)) && blast(contentFB)
        .then(function (res) {
          res.error && this.onError(res.error)
        }.bind(this))
        .then(() => campRef.child(this.broadcastId).update({ approval: 'approved', sent: !this.errorBlast })
        )
      this.broadcast.messenger && !this.broadcast.sms && blast(contentFB)
        .then(function (res) {
          res.error && this.onError(res.error)
        }.bind(this))
        .then(() => campRef.child(this.broadcastId).update({ approval: 'approved', sent: !this.errorBlast })
        )
      this.broadcast.sms && !this.broadcast.messenger && blast(contentSMS)
        .then(function (res) {
          res.error && this.onError(res.error)
        }.bind(this))
        .then(() => campRef.child(this.broadcastId).update({ approval: 'approved', sent: !this.errorBlast })
        )
    },
    onDeny() {
      campRef.child(this.broadcastId).update({ approval: 'denied' })
    },
    onError(error) {
      this.errorBlast = true
      this.$snotify.error(error)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Campaign.vue?03266b9a